export class LanguageCode {
  /**
   * Canonical form for comparisons, URL segments and lookup keys. Language tags are
   * case-insensitive ASCII per BCP-47, so plain `toLowerCase()` is the correct fold — not
   * `toLocaleLowerCase()`, which under a Turkish locale turns 'it-IT' into 'it-ıt', nor
   * `String#equalsIgnoreCase`, which compares through locale-sensitive collation.
   */
  public static normalize(languageCode: string): string {
    return languageCode?.toLowerCase();
  }

  public static areEqual(left: string, right: string): boolean {
    if (!left || !right) {
      return false;
    }

    return LanguageCode.normalize(left) === LanguageCode.normalize(right);
  }

  public static isAnyOf(languageCode: string, languages: ReadonlyArray<{ code: string }>): boolean {
    return languages.some((x) => LanguageCode.areEqual(x.code, languageCode));
  }
}
